import { useMemo } from 'react';

import { BREAKPOINTS } from '@skyscanner-internal/backpack-web/bpk-component-breakpoint';
import BpkText from '@skyscanner-internal/backpack-web/bpk-component-text';
import { useSelector } from 'react-redux';

import getFeatureDecision from '../../../../config';
import { ENABLE_DEPARTURE_TIMES } from '../../../../config/constants';
import { useMediaQuery } from '../../helpers/hooks/useMediaQuery';
import { useTranslation } from '../../helpers/hooks/useTranslation';
import { isReturn } from '../../selectors';
import { DepartureTimesFilter } from '../DepartureTimesFilter/DepartureTimesFilter';
import { getComponentWithDirection } from '../MonthSelector/MonthSelector';

import './CalendarNav.scss';

import type { Direction } from '../../selectors/types';

export const CalendarNav = ({
  direction,
  id,
}: {
  direction: Direction;
  id: string;
}) => {
  // returns MonthSelector using helper getComponentWithDirection alongside DepartureTimesSelect
  const isReturnTrip = useSelector(isReturn);
  const departureTimesVariant = getFeatureDecision(ENABLE_DEPARTURE_TIMES, 'A');
  const enableDepartureTimes = departureTimesVariant !== 'A' && !isReturnTrip;
  const singleSelect = departureTimesVariant === 'B';
  const stackedFilter = enableDepartureTimes && !singleSelect;
  const MonthSelectorWithDirection = useMemo(
    () => getComponentWithDirection(direction),
    [direction],
  );
  const isMobile = useMediaQuery(BREAKPOINTS.MOBILE);
  const translate = useTranslation();
  return (
    <div
      className={`calendar-nav${stackedFilter ? ' calendar-nav--stacked' : ''}`}
    >
      <div className="calendar-nav__month-selector">
        <MonthSelectorWithDirection id={id} />
      </div>
      {enableDepartureTimes && (
        <div className="calendar-nav__filter">
          {(isMobile || stackedFilter) && (
            <BpkText>{translate('mvp_departure_time')}</BpkText>
          )}
          <DepartureTimesFilter />
        </div>
      )}
    </div>
  );
};

export const getCalendarNav = ({
  direction,
  id,
}: {
  direction: Direction;
  id: string;
}) => <CalendarNav direction={direction} id={id} />;
